import {jsx as _jsx} from "react/jsx-runtime";import {Suspense} from 'react'

import teamInvitationQuery, {} from '~/__generated__/TeamInvitationQuery.graphql'
import useNoIndex from '~/hooks/useNoIndex'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import TeamInvitation from './TeamInvitation'



const TeamInvitationRoot = (props) => {
  useNoIndex()
  const {match} = props
  const {params} = match
  const {token} = params
  const queryRef = useQueryLoaderNow(teamInvitationQuery, {token})
  return _jsx(Suspense, { fallback: '', children: queryRef && _jsx(TeamInvitation, { queryRef: queryRef,} )})
}

export default TeamInvitationRoot
